export default [
  {
    path: '/incomes_extract',
    name: 'IncomesExtract',
    meta: { 
      auth: true,
      roles: ['Director'],
    },
    component: () => import("@/_backoffice/_financial/components/income_extract/ListExtracts.vue"),
  },
]
